import modelmain from "./378_MainSeat.glb";
import ribs from "./378_Ribs.glb";
import logomain from "./378_MainLogo.glb";
import logohexa from "./378_HexaLogo.glb";
import leftBolt from "./378_SideLogoLeftBolt.glb";
import leftEnjoy from "./378_SideLogoLeftEnjoy.glb";
import rightBolt from "./378_SideLogoRightBolt.glb";
import rightEnjoy from "./378_SideLogoRightEnjoy.glb";
import number from "./378_Number.glb";
import { degsToRads } from "../../../utilities";

// This is the eBike2 seat Model (AKA Super 73)

// Link to test
// /?type=ebike2&subtype=ribbed&test=yes

const modelParts = {
  main: modelmain,
  ribs: ribs,
  logoMain: logomain,
  logoHexa: logohexa,
  number: number,
};

const leftLogoParts = {
  bolt: leftBolt,
  enjoyMfg: leftEnjoy,
};
const rightLogoParts = {
  bolt: rightBolt,
  enjoyMfg: rightEnjoy,
};

const leftLogoCoords = {
  bolt: {
    position: [0.122, -0.083, 0.217],
    rotation: [1.574, 0, -Math.PI / 2],
    scale: 0.359,
  },
  enjoyMfg: {
    position: [0.123, -0.064, 0.236],
    rotation: [1.569, 0, -Math.PI / 2],
    scale: 0.628,
  },
};
const rightLogoCoords = {
  bolt: {
    position: [-0.125, -0.071, 0.21],
    rotation: [1.551, 0, Math.PI / 2],
    scale: 0.374,
  },
  enjoyMfg: {
    position: [-0.127, -0.064, 0.24],
    rotation: [1.577, 0, Math.PI / 2],
    scale: 0.613,
  },
};

// const numberCoords = {
//   modelPosition: [0, 0.1068, -0.349],
//   modelRotation: [degsToRads(14.386), 0, 0],
//   modelScale: [1.215, 1.215, 1.215],
//   textPosition: [0, 0.0029, 0],
//   textRotation: [degsToRads(-14.386), degsToRads(0), degsToRads(0)],
//   // textRotation: [-1.251, 0, 0],
//   textScale: 0.038,
//   curveRadius: -12,
// };

const numberCoords = {
  modelPosition: [0, 0.112, -0.38],
  modelRotation: [0, 0, 0],
  textPosition: [-0.016, 0.05, -0.38],
  textRotation: [Math.PI / -2.36, 0, 0],
  textScale: 0.31,
  decalSize: 0.08,
  letterSpacing: 0.01,
  aspectRatio: [3, 1],
};

export {
  modelParts,
  leftLogoCoords,
  rightLogoCoords,
  leftLogoParts,
  rightLogoParts,
  numberCoords,
};
